import { render, staticRenderFns } from "./wxcallback.vue?vue&type=template&id=5f57833b&"
import script from "./wxcallback.vue?vue&type=script&lang=js&"
export * from "./wxcallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports